import script from "./ButtonSuccess.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonSuccess.vue?vue&type=script&setup=true&lang=js"

import "./ButtonSuccess.vue?vue&type=style&index=0&id=604b47b3&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-604b47b3"]])

export default __exports__